import { useQuery } from "@tanstack/react-query";
import { Agent } from "api/agent";

const baseQueryConfig = {
  staleTime: Infinity,
  enabled: false,
  retry: false,
  refetchOnReconnect: false,
  refetchOnWindowFocus: false,
  refetchOnMount: false,
};

export const useGetTasks = (
  { status = "", dateFrom = "", dateTo = "", pageNumber = -1, pageSize = -1 },
  options = {}
) => {
  return useQuery({
    queryKey: ["getTasks", status, dateFrom, dateTo, pageNumber, pageSize],
    queryFn: () =>
      Agent.taskReports.getTasks({
        status: status,
        dateFrom: dateFrom,
        dateTo: dateTo,
        pageNumber: pageNumber,
        pageSize: pageSize,
      }),
    staleTime: 1000 * 60 * 60,
    ...options,
  });
};

export const useGetTasksPerMaintenanceType = (
  { dateFrom = "", dateTo = "", pageNumber = -1, pageSize = -1 },
  options = {}
) => {
  return useQuery({
    queryKey: [
      "getTasksPerMaintenanceType",
      dateFrom,
      dateTo,
      pageNumber,
      pageSize,
    ],
    queryFn: () =>
      Agent.taskReports.getTasksPerMaintenanceType({
        dateFrom: dateFrom,
        dateTo: dateTo,
        pageNumber: pageNumber,
        pageSize: pageSize,
      }),
    staleTime: 1000 * 60 * 60,
    ...options,
  });
};

export const useExportTasks = ({
  status = "",
  exportType = "",
  dateFrom = "",
  dateTo = "",
}) => {
  return useQuery({
    queryKey: ["exportTasks", exportType, dateFrom, dateTo, status],
    queryFn: () =>
      Agent.taskReports.exportTasks({
        status: status,
        exportType: exportType,
        dateFrom: dateFrom,
        dateTo: dateTo,
      }),
    ...baseQueryConfig,
  });
};

export const useExportTasksPerMaintenanceType = ({
  exportType = "",
  dateFrom = "",
  dateTo = "",
}) => {
  return useQuery({
    queryKey: ["exportTasksPerMaintenanceType", exportType, dateFrom, dateTo],
    queryFn: () =>
      Agent.taskReports.exportTasksPerMaintenanceType({
        exportType: exportType,
        dateFrom: dateFrom,
        dateTo: dateTo,
      }),
    ...baseQueryConfig,
  });
};
